export const CONSTELLATION_SIZE = 48;
export const CONSTELLATION_CENTER: number = CONSTELLATION_SIZE / 2;
export const CONSTELLATION_DOT_COUNT = 19;
export const CONSTELLATION_DOT_DIAMETER: number =
	Math.ceil(((4 * CONSTELLATION_SIZE) / 48) * 2) / 2;
export const CONSTELLATION_FORMATION_RADIUS: number = CONSTELLATION_SIZE * 0.36;
export const FULL_ROTATION_RADIANS: number = Math.PI * 2;
/** The golden ratio (φ) is approximately equal to 1.618. */
export const GOLDEN_RATIO: number = (1 + Math.sqrt(5)) / 2;
